<template>
	<div class="chat-cell" :class="!is_amin?'chat-left':'chat-right'">
	  <div class="chat-content">
		
		<div class="time">
			<span>{{!is_amin?'用户: ':'admin: '}}</span>
			<span>{{ getYMDHMS(message.create_time*1000) }}</span>
		</div>
		<div class="message">{{ !is_amin?message.user_message:message.admin_message }}</div>
	  </div>
	</div>
  </template>
  

<script>
	import { getYMDHMS } from '../../utils';
	export default {
		name:'consult-label',
		props: {
			message: {
				type: Object,
				default: {}
			},
		},
		data() {
			return {
				is_amin: false,
				getYMDHMS
			}
		},
		mounted() {
			if(this.message.admin_message.length && this.message.admin_username.length){
				this.is_amin = true
			}
		},
	}
</script>

<style lang="less">
	.chat-cell {
	  display: flex;
	  margin: 15px 0;
	}
	
	.chat-cell.chat-left {
	  justify-content: flex-start;
	}
	
	.chat-cell.chat-right {
	  justify-content: flex-end;
	}
	
	.chat-content {
	  max-width: 70%;
	  padding: 8px 12px;
	  border-radius: 5px;
	  position: relative;
	}
	
	.chat-left .chat-content {
	  background-color: #f0f0f0;
	  margin-left: 5px;
	  text-align: left;
	}
	
	.chat-right .chat-content {
	  background-color: #1890ff;
	  color: white;
	  margin-right: 5px;
	  text-align: left;
	}
	
	.message {
	  word-wrap: break-word;
	  margin-top: 4px;
	}
	
	.time {
	  font-size: 12px;
	  opacity: 0.8;
	}
	
	.chat-left .time {
	  text-align: left;
	}
	
	.chat-right .time {
	  text-align: right;
	}
</style>